<template>
<html lang="en">
<body>
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title><h1>My Resume!!</h1></title>
  

</head>

<link href='https://fonts.googleapis.com/css?family=Lato:400,300,700' rel='stylesheet' type='text/css'>

<div class="container">
<!--SECTION INFO-->

  <div class="header">
    <div style="float: right ;" >
      <div class="contact-info" >
      <router-link class="button1" to='/myenglishform'>Contact</router-link> <span class="separator"></span> <router-link class="button1" to='/myfrenchresume'>Français</router-link><span class="separator"></span><router-link class="button1" to='/myenglishresume'>English</router-link>
      </div>
    </div>
 <div> &nbsp; </div>
    <div> &nbsp; </div>
    <div class="full-name">
      <span class="first-name">{{firstName}}</span>
      <span class="last-name">{{lastName}}</span>
      
    </div>
    
    <div class="contact-info">
      <span class="email">Email: </span>
      <span class="email-val">{{email}}</span>
      <span class="separator"></span>
      <span class="phone">Phone: </span>
      <span class="phone-val">{{phone}}</span>
    </div>
  
    <div class="about">
      <span class="position">Freelance Back-End Developer</span>
      <span class="desc">
        {{description}}
      </span>
    </div>
  </div>
<!--END OF SECTION INFO-->
<hr>
  <div class="details">
     <div class="section">
     <!--<div class="section__title">Experience</div>
      <div class="section__list">
        <div class="section__list-item">
          <div class="left">
            <div class="name">KlowdBox</div>
            <div class="addr">San Fr, CA</div>
            <div class="duration">Jan 2011 - Feb 2015</div>
          </div>
          <div class="right">
            <div class="name">Fr developer</div>
            <div class="desc">did This and that</div>
          </div>
        </div>
        <div class="section__list-item">
          <div class="left">
            <div class="name">Akount</div>
            <div class="addr">San Monica, CA</div>
            <div class="duration">Jan 2011 - Feb 2015</div>
          </div>
          <div class="right">
            <div class="name">Fr developer</div>
            <div class="desc">did This and that</div>
          </div>
        </div>

      </div>-->
    </div>
    
    <div class="section">
      <div class="section__title">Education</div>
      <div class="section__list">
        <div class="section__list-item">
          <div class="left">
            <div class="name">{{Info}}</div>
            <!--<div class="addr">San Fr, CA</div>
            <div class="duration">Jan 2011 - Feb 2015</div>-->
          </div>
          
          <div class="right">
            <!--<div class="name">Fr developer</div>
            <div class="desc">did This and that</div>-->
          </div>
        </div>
        <!--<div class="section__list-item">
          <div class="left">
            <div class="name">Akount</div>
            <div class="addr">San Monica, CA</div>
            <div class="duration">Jan 2011 - Feb 2015</div>
          </div>
          <div class="right">
            <div class="name">Fr developer</div>
            <div class="desc">did This and that</div>
          </div>
        </div>-->

      </div>

    </div>
   
    <div class="section">
      <div class="section__title">KEY SKILLS</div>
      <div class="section__list">
        <div class="section__list-item">
          <div class="left">
            <div class="name">Coding Languages: </div>
                <div class="desc">{{languages}}</div>
            <div class="name">Frameworks:</div>
            <div class="desc">{{frameworks}}</div>
            <div class="name">Librairies:</div>
            <div class="desc">{{librairies}}</div>
            <div class="name">Web Services:</div>
            <div class="desc">{{webServices}}</div>
            <div class="name">DataBases:</div>
            <div class="desc">{{database}}</div>
            <div class="name">Os:</div>
            <div class="desc">{{systems}}</div>
            <div class="name">IDEs:</div>
            <div class="desc">{{ide}}</div>
            <!--<div class="addr">San Fr, CA</div>
            <div class="duration">Jan 2011 - Feb 2015</div>-->
          </div>
          
          <!--<div class="right">
            <div class="name">Fr developer</div>
            <div class="desc">did This and that</div>
          </div>-->
        </div>
       <!-- <div class="section__list-item">
          <div class="left">
            <div class="name">Akount</div>
            <div class="addr">San Monica, CA</div>
            <div class="duration">Jan 2011 - Feb 2015</div>
          </div>
          <div class="right">
            <div class="name">Fr developer</div>
            <div class="desc">did This and that</div>
          </div>
        </div>-->

      </div>

    </div>
    <div class="section">
      <div class="section__title">Languages</div>
      <div class="section__list">

        <div class="section__list-item">
          <div class="text">{{englais}}
          </div>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="section__title">COMPETENCIES</div>
      <div class="section__list">

        <div class="section__list-item">
          <!--<div class="name">DSP</div>-->
          <div class="text">{{projects}}<!--<a href="/login">link</a>-->
          </div>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="section__title">Skills</div>
      <div class="skills">
        <div class="skills__item">
          <div class="left">
            <div class="name">
              Javascript
            </div>
          </div>
          <div class="right">
            <input id="ck1" type="checkbox" checked />

            <label for="ck1"></label>
            <input id="ck2" type="checkbox" checked />

            <label for="ck2"></label>
            <input id="ck3" type="checkbox"  checked/>

            <label for="ck3"></label>
            <input id="ck4" type="checkbox"  checked/>
            <label for="ck4"></label>
            <input id="ck5" type="checkbox" />
            <label for="ck5"></label>

          </div>
        </div>
        <div class="skills__item">
          <div class="left">
            <div class="name">
              Nodejs
            </div>
          </div>
          <div class="right">
            <input id="ck1" type="checkbox" checked />

            <label for="ck1"></label>
            <input id="ck2" type="checkbox" checked />

            <label for="ck2"></label>
            <input id="ck3" type="checkbox"  checked/>

            <label for="ck3"></label>
            <input id="ck4" type="checkbox"  checked/>
            <label for="ck4"></label>
            <input id="ck5" type="checkbox" />
            <label for="ck5"></label>

          </div>
        </div>

      </div>
      <div class="skills__item">
        <div class="left">
          <div class="name">
            VueJS</div>
        </div>
        <div class="right">
          <input id="ck1" type="checkbox" checked />

          <label for="ck1"></label>
          <input id="ck2" type="checkbox" checked />

          <label for="ck2"></label>
          <input id="ck3" type="checkbox" checked/>

          <label for="ck3"></label>
          <input id="ck4" type="checkbox" checked/>
          <label for="ck4"></label>
          <input id="ck5" type="checkbox" />
          <label for="ck5"></label>

        </div>
        
      </div>
      <div class="skills__item">
        <div class="left">
          <div class="name">
            Python</div>
        </div>
        <div class="right">
          <input id="ck1" type="checkbox" checked />

          <label for="ck1"></label>
          <input id="ck2" type="checkbox" checked />

          <label for="ck2"></label>
          <input id="ck3" type="checkbox" checked/>

          <label for="ck3"></label>
          <input id="ck4" type="checkbox" checked/>
          <label for="ck4"></label>
          <input id="ck5" type="checkbox" />
          <label for="ck5"></label>

        </div>
        
      </div>
  <div class="skills__item">
        <div class="left">
          <div class="name">
            C++</div>
        </div>
        <div class="right">
          <input id="ck1" type="checkbox" checked />

          <label for="ck1"></label>
          <input id="ck2" type="checkbox" checked />

          <label for="ck2"></label>
          <input id="ck3" type="checkbox" checked/>

          <label for="ck3"></label>
          <input id="ck4" type="checkbox" />
          <label for="ck4"></label>
          <input id="ck5" type="checkbox" />
          <label for="ck5"></label>

        </div>
        
      </div>

    </div>
    <hr>
    <div class="section">
      <div class="section__title">
        {{hobby}}
      </div>
      <div class="section__list">
        <div class="section__list-item">
         {{interest}}
        </div>
      </div>
    </div>
  </div>
</div>
</body>
</html>

</template>

<script>

 export default {
    data(){
     return{
    firstName:'Stone',
    lastName:'Fletcher',
    email:'xxpressweb@gmail.com',
    phone:'+33772290659',
    description:`
    Accomplished and very experienced Nodejs developer with a complete mastery of
    lots of Nodejs modules. Able to work independently with little or no
    supervision as well as within a team as a full member.`,
    Info:`Self-taught developer in (Javascript, Vue.js, Node.js, C++, Python).`,
    languages:'Javascript , C++, Python, little knowledge in( ES6 and Typescript).',
    frameworks:'Nodejs, Vuejs. Ajax.',
    librairies:'Mocha, Chai, Axios, Express.js, Socket.io, Cheerio, Brain.js, Npm, Async/await, Request, Parser, Nodemailer, JQuery.',
    webServices:'Heroku, AWS.',
    database:'Firebase, MongoDb.',
    systems:'Microsoft Windows, UNIX/Linux.',
    ide:'Visual Studio Code, Code::Blocks, Spyder.',
    englais:'English (fluent).',
    interest:'Music, Cinema, Reading, Travel.',
    hobby:'HOBBIES & INTERESTS',
    projects:`
    I'm a Back-end developer with over 3 years of experience with Node.js, Vue.js, Python and Javascript. I'm motivated, result-focused and seeking a successful company that emphasizes teamwork and lifelong learning.`,
  };
},

}
</script>

